import register from 'ShopUiBundle/modules/app/registry';

// tslint:disable-next-line
register('toggle-subform', () => import(/* webpackMode: "lazy" */'./toggle-subform'));
